{
  "name": "serv-e-go-frontend",
  "version": "3.10.3",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration=remoteAPI --host 0.0.0.0 --port 4200",
    "start:testAPI": "ng serve --configuration=testAPI --host 0.0.0.0 --port 4200",
    "start:wiremock": "ng serve --configuration=wiremock --host 0.0.0.0 --port 4201",
    "watch": "ng serve --configuration=local",
    "wiremock:up": "docker compose up wiremock -d",
    "wiremock:down": "docker compose down wiremock",
    "wiremock:logs": "docker compose logs -f wiremock",
    "wiremock:reload": "curl -X POST http://localhost:8081/__admin/mappings/reset",
    "build": "ng build --output-hashing=bundles --configuration production --stats-json",
    "build:local": "ng build --output-hashing=bundles --configuration=local",
    "check:commit-message": "commitlint --config .commitlintrc.cjs --edit",
    "lint": "npm run check:playwright-unused-screenshots && npx eslint . && npx stylelint \"src/**/*.{scss,css}\" && npx prettier --check .",
    "check:pre-push": "npm run check:visual-impact && npm run typecheck:incremental",
    "check:visual-impact": "node tools/hooks/check-visual-impact.mjs",
    "typecheck": "tsc -p tsconfig.json --noEmit --skipLibCheck",
    "typecheck:incremental": "tsc -p tsconfig.json --noEmit --skipLibCheck --incremental --tsBuildInfoFile node_modules/.cache/servego-typecheck.tsbuildinfo",
    "prettier": "prettier --write ./src/app/**/*.ts",
    "checkTrad": "node tools/i18n/findMissingKeys.js",
    "test": "ng test --no-watch",
    "test:watch": "ng test --watch",
    "test:coverage": "ng test --no-watch --coverage",
    "test:ci": "ng test --no-watch --configuration ci && cp coverage/serv-e-go-frontend/lcov.info coverage/lcov.info",
    "test:integration:bdd": "TS_NODE_PROJECT=tests/integration/tsconfig.json cucumber-js",
    "test:integration:bdd:run": "tests/integration/run-bdd-tests.sh",
    "test:integration:bdd:run:progress": "tests/integration/run-bdd-tests.sh --profile progress",
    "test:integration:ci": "tests/integration/run-bdd-tests-ci.sh",
    "test:visual:ci": "npx playwright test --shard=${CI_NODE_INDEX:-1}/${CI_NODE_TOTAL:-1}",
    "test:ihm": "npm run test:ihm:linux",
    "test:ihm:linux": "docker compose -f tests/visual-regression-tests/docker/docker-compose.yml down --remove-orphans && docker compose -f tests/visual-regression-tests/docker/docker-compose.yml run servego-playwright npx playwright test",
    "test:ihm:linux-storybook": "npm run test:ihm:linux -- --project=storybook-chromium --project=storybook-firefox --project=storybook-webkit",
    "test:ihm:linux-storybook-update": "npm run test:ihm:linux-storybook -- --update-snapshots",
    "test:ihm-build-docker-image": "docker build -t servego-playwright tests/visual-regression-tests/docker/",
    "test:ihm-report": "npx playwright show-report",
    "test:ihm-clean": "find . -type d -name '*-snapshots' -exec sh -c 'rm -f \"$0\"/*.png' {} \\;",
    "test:ihm-update-snapshots": "npm run test:ihm:linux -- --update-snapshots",
    "bundle-report": "webpack-bundle-analyzer dist/stats.json",
    "outdated": "npx --yes -- check-outdated --ignore-pre-releases --columns name,current,latest,changes --types minor,patch,reverted",
    "prepare": "husky",
    "update-i18n": "bash update-i18n.sh",
    "prestorybook": "msw init",
    "storybook": "storybook dev -p 6006",
    "prebuild-storybook": "msw init",
    "build-storybook": "storybook build -o storybook-static",
    "docker:storybook": "docker compose -f storybook/docker-compose.yml up storybook",
    "check:playwright-unused-screenshots": "ts-node --transpile-only --project tools/playwright/tsconfig.json tools/playwright/check-unused-screenshots.ts",
    "delete:playwright-unused-screenshots": "ts-node --transpile-only --project tools/playwright/tsconfig.json tools/playwright/delete-unused-screenshots.ts"
  },
  "engines": {
    "node": "^24.15.0",
    "npm": "^12.0.0"
  },
  "private": true,
  "dependencies": {
    "@angular-devkit/core": "22.2.2",
    "@angular/animations": "22.2.2",
    "@angular/cdk": "22.2.2",
    "@angular/common": "22.2.2",
    "@angular/compiler": "22.2.2",
    "@angular/core": "22.2.2",
    "@angular/forms": "22.2.2",
    "@angular/material": "22.2.2",
    "@angular/material-luxon-adapter": "22.2.2",
    "@angular/platform-browser": "22.2.2",
    "@angular/platform-browser-dynamic": "22.2.2",
    "@angular/router": "22.2.2",
    "@daily-co/daily-js": "0.94.0",
    "@ngx-translate/core": "18.0.0",
    "angular-auth-oidc-client": "22.0.2",
    "bootstrap": "5.3.8",
    "chart.js": "4.5.1",
    "flat": "6.0.1",
    "jsonpath-plus": "11.2.1",
    "leaflet": "1.9.4",
    "leaflet.markercluster": "1.5.3",
    "luxon": "3.7.2",
    "ng2-charts": "11.0.0",
    "ngx-mask": "22.2.5",
    "rxjs": "7.8.2",
    "socket.io-client": "4.8.4",
    "tslib": "2.8.1",
    "unleash-proxy-client": "3.8.2",
    "zone.js": "0.16.3"
  },
  "devDependencies": {
    "@analogjs/storybook-angular": "2.9.0",
    "@angular-devkit/architect": "0.2202.2",
    "@angular-devkit/build-angular": "22.2.2",
    "@angular-eslint/builder": "22.6.0",
    "@angular/build": "22.2.2",
    "@angular/cli": "22.2.2",
    "@angular/compiler-cli": "22.2.2",
    "@angular/language-service": "22.2.2",
    "@commitlint/cli": "21.2.4",
    "@commitlint/config-conventional": "21.2.4",
    "@cucumber/cucumber": "13.3.0",
    "@cucumber/pretty-formatter": "4.1.0",
    "@playwright/test": "1.64.1",
    "@storybook/addon-a11y": "10.6.2",
    "@storybook/addon-docs": "10.6.2",
    "@storybook/angular": "10.6.2",
    "@types/leaflet": "1.9.22",
    "@types/leaflet.markercluster": "1.5.6",
    "@types/luxon": "3.7.6",
    "@types/node": "24.19.2",
    "@vitest/browser-playwright": "5.0.5",
    "@vitest/coverage-v8": "5.0.5",
    "angular-eslint": "22.6.0",
    "eslint": "10.13.0",
    "eslint-import-resolver-typescript": "4.4.5",
    "eslint-plugin-import-x": "4.17.1",
    "eslint-plugin-storybook": "10.6.2",
    "http-server": "14.1.1",
    "husky": "9.1.7",
    "lint-staged": "17.6.0",
    "msw": "3.0.3",
    "msw-storybook-addon": "3.0.3",
    "poeditorial": "2.2.1",
    "prettier": "3.9.10",
    "socket.io-mock": "1.3.2",
    "storybook": "10.6.2",
    "stylelint": "17.16.0",
    "stylelint-config-standard-scss": "17.0.0",
    "stylelint-order": "8.1.2",
    "ts-node": "10.9.2",
    "typescript": "6.0.3",
    "typescript-eslint": "8.72.0",
    "vitest": "5.0.5",
    "webpack-bundle-analyzer": "5.4.0"
  },
  "lint-staged": {
    "src/{app,environments,styles}/**/*.ts": [
      "prettier --write",
      "eslint --fix"
    ],
    "src/{app,environments,styles}/**/*.{scss,css,md}": [
      "prettier --write",
      "stylelint --fix"
    ],
    "src/{app,environments,styles}/**/*.html": [
      "prettier --write",
      "eslint --fix"
    ]
  },
  "msw": {
    "workerDirectory": [
      ".storybook/public"
    ]
  }
}
